module.exports = __webpack_public_path__ + "img/AWS.cde4c703.png";